import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LogoComponent } from './logo/logo.component';
import { NotificationModule } from '@progress/kendo-angular-notification';
import { LayoutModule } from '@progress/kendo-angular-layout';
import {
  provideLottieOptions,
  provideCacheableAnimationLoader,
  LottieComponent,
} from 'ngx-lottie';
import { StatusAlertComponent } from './components/status-alert/status-alert.component';
import { IndicatorsModule } from '@progress/kendo-angular-indicators';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';

import { LanguageDropdownSelectorComponent } from './components/language-dropdown-selector/language-dropdown-selector.component';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { TooltipModule } from '@progress/kendo-angular-tooltip';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LabelModule } from '@progress/kendo-angular-label';
import { DialogModule } from '@progress/kendo-angular-dialog';
import { HasPermissionDirective } from './directives/has-permission.directive';
import { AutofocusDirective } from './directives/autofocus/autofocus.directive';
import {
  CldrIntlService,
  IntlModule,
  IntlService,
} from '@progress/kendo-angular-intl';

@NgModule({
  declarations: [AutofocusDirective],
  imports: [
    CommonModule,
    HasPermissionDirective,
    LottieComponent,
    TranslateModule,
    LabelModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    InputsModule,
    ButtonsModule,
    DropDownsModule,
    NotificationModule,
    LayoutModule,
    TooltipModule,
    DialogModule,
    IntlModule,
    LogoComponent,
    StatusAlertComponent,
    LanguageDropdownSelectorComponent,
  ],
  exports: [
    CommonModule,
    LogoComponent,
    StatusAlertComponent,
    LottieComponent,
    TranslateModule,
    LabelModule,
    FormsModule,
    ReactiveFormsModule,
    TooltipModule,
    IndicatorsModule,
    InputsModule,
    DropDownsModule,
    ButtonsModule,
    HasPermissionDirective,
    AutofocusDirective,
    IntlModule,
    LanguageDropdownSelectorComponent,
  ],
  providers: [
    provideLottieOptions({ player: () => import('lottie-web') }),
    provideCacheableAnimationLoader(),
    {
      provide: IntlService,
      useExisting: CldrIntlService,
    },
  ],
})
export class SharedModule {}
